'use client';

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, useEffect, useState } from 'react';
import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';
import { getEnv } from '@/utils/env';

/**
 * `surveys` gates PostHog's survey bundle (`surveys.js` plus its `/api/surveys/` call), which loads by
 * default. A survey popping up mid-lab on the public preview would interrupt a five-minute flow for a
 * visitor with no account, and it is another third-party payload on a route with no consent gate.
 */
export function PostHogProvider(t0) {
  const $ = _c(5);
  const {
    children,
    surveys: t1
  } = t0;
  const surveys = t1 === undefined ? true : t1;
  const [isLoaded, setIsLoaded] = useState(false);
  let t2;
  if ($[0] !== surveys) {
    t2 = () => {
      const apiKey = getEnv("POSTHOG_KEY");
      if (apiKey) {
        posthog.init(apiKey, {
          api_host: "https://posthog.extern.com",
          ui_host: "https://us.posthog.com",
          person_profiles: "identified_only",
          autocapture: false,
          capture_pageview: false,
          capture_pageleave: false,
          capture_exceptions: false,
          capture_performance: false,
          capture_heatmaps: false,
          capture_dead_clicks: false,
          disable_session_recording: true,
          disable_surveys: !surveys,
          bootstrap: {
            featureFlags: {}
          }
        });
        posthog.onFeatureFlags(() => {
          setIsLoaded(true);
        });
      }
    };
    $[0] = surveys;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  useEffect(t2, t3);
  if (!isLoaded) {
    return null;
  }
  let t4;
  if ($[3] !== children) {
    t4 = <PHProvider client={posthog}>{children}</PHProvider>;
    $[3] = children;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}